export interface Block {
    type: string;
}
export const idGenerator = () => `_${Math.random().toString(36).substr(2, 9)}`;
